<div class="fab-wylicz-pozniej-usun"
     *ngIf="state === FabState.active"
     (click)="toggle()">
</div>

<div class="fab-wylicz-pozniej">
    <div matFab title="" class="fab-wylicz-pozniej-icon" (click)="toggle()">
        <em [@fabToggler]="{value: state}" class="icon-koperta"></em>
    </div>
</div>

<div class="fab-wylicz-pozniej-content">
    <div [@fabDialer]="state === FabState.active ? 1 : 0">

        <div *ngIf="state === FabState.active" class="c-card">
            <div class="text-center">
                <h2 class="text-20">
                    Jeżeli chcesz otrzymać link
                    <br>do wyliczenia Twojej szkody później
                </h2>
            </div>
            <div class="o-flex__item u-flex-1/1@desktop u-flex-1/1@small text-center align-content-center">
                <div appThrottleClick (clickFunction)="wyslijLink()" class="c-button c-button--primary pl-5 pr-5">WYLICZ PÓŹNIEJ</div>
            </div>
        </div>

    </div>
</div>
